export default __webpack_public_path__ + "static/rsz_1be7_marcin_jasinski-8ac5f38f120e7340cdc3ff791c190bc4.jpg";